var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.45 0.950195C22.8337 0.950195 0.449951 23.334 0.449951 50.9502C0.449951 78.5664 22.8337 100.95 50.45 100.95C78.0662 100.95 100.45 78.5664 100.45 50.9502C100.45 23.334 78.0662 0.950195 50.45 0.950195ZM38.0365 75.6386L16.1473 49.8028L24.446 42.7702L39.3125 60.3073L77.0968 28.3389L84.1295 36.6475L38.0464 75.6386H38.0365Z",
    fill: "#82BCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.327d67b6f557d096d008f9ca17b3cc65.svg";
export { ForwardRef as ReactComponent };